import { IconV1 } from 'common/icon/iconV1.js';
import { TableDataHeaders } from 'types/data-tables/column-by-key.js';
import { RenderHeaderProps } from 'utilities/buildTables/headers/renderHeader.js';

export function RenderHeaderThreeHourlySlot({
  headers,
  cellInfo,
  getCellClassNames,
}: RenderHeaderProps<TableDataHeaders> & { alignCenter?: boolean }) {
  const getIcon = () => {
    const { icon } = headers;
    return (
      <div data-module="render-header-3hr" className="IconWithText IconWithText--small IconWithText--vCenter">
        <div className="IconWithText-icon">{icon && <IconV1 icon={icon} />}</div>
      </div>
    );
  };

  const getText = () => {
    const { title: text } = headers;
    return (
      <div data-module="render-header-3hr" className="u-pL-0">
        <span>{text}</span>
      </div>
    );
  };

  const genericClassNames = getCellClassNames(cellInfo);
  return (
    <>
      <th className={`small u-textRegular u-textTruncate no-width sticky-col u-pR-0 ${genericClassNames}`}>
        {getIcon()}
      </th>
      <th className={`small u-textRegular u-textTruncate`}>{getText()}</th>
    </>
  );
}
